import { createSlice } from "@reduxjs/toolkit";

const initialState = { authStatus: false };

export const authenticationSlice = createSlice({
  name: "authentication",
  initialState: initialState,
  reducers: {
    login(state) {
      state.authStatus = true;
    },
    reset(state) {
      state.authStatus = false;
    },
  },
});
